// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phonesvg[data-v-0f0e230d]{width:23px;height:23px}.phonesvg path[data-v-0f0e230d]{fill:#575757}body[data-theme=night] .phonesvg path[data-v-0f0e230d]{fill:#dadada}", ""]);
// Exports
module.exports = exports;
